<script lang="ts">
  // SEO Backlinks section for building authority and improving search rankings
  const partnerLinks = [
    { name: 'PrizeRewards.com', url: '#', description: 'Top prize rewards platform' },
    { name: 'DailyGiveaways.net', url: '#', description: 'Daily giveaways & contests' },
    { name: 'WinCash.org', url: '#', description: 'Win cash prizes online' },
    { name: 'FreeSpinHub.io', url: '#', description: 'Free spin games hub' },
  ];
  
  const resourceLinks = [
    { name: 'How to Win Online Contests', url: '#' },
    { name: 'Best Prize Games 2024', url: '#' },
    { name: 'Legit Sweepstakes Guide', url: '#' },
    { name: 'Online Gaming Tips', url: '#' },
  ];
</script>

<section class="backlinks-section">
  <div class="backlinks-container">
    <!-- Partner Sites -->
    <div class="link-group">
      <h3>Our Trusted Partners</h3>
      <ul class="partner-links">
        {#each partnerLinks as link}
          <li>
            <a href={link.url} rel="dofollow" target="_blank" title={link.description}>
              {link.name}
            </a>
            <span class="link-desc">{link.description}</span>
          </li>
        {/each}
      </ul>
    </div>
    
    <!-- Resources -->
    <div class="link-group">
      <h3>Helpful Resources</h3>
      <ul class="resource-links">
        {#each resourceLinks as link}
          <li>
            <a href={link.url} rel="dofollow">{link.name}</a>
          </li>
        {/each}
      </ul>
    </div>
    
    <!-- Social Proof Links -->
    <div class="link-group">
      <h3>As Featured On</h3>
      <div class="featured-logos">
        <span class="logo-placeholder">🏆 TechCrunch</span>
        <span class="logo-placeholder">⭐ Forbes</span>
        <span class="logo-placeholder">📰 Business Insider</span>
        <span class="logo-placeholder">🎮 IGN</span>
      </div>
    </div>
  </div>
</section>

<style>
  .backlinks-section {
    background: #f8f9fa;
    padding: 50px 20px;
    margin: 40px 0;
    border-radius: 20px;
  }
  
  .backlinks-container {
    max-width: 1000px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 40px;
  }
  
  .link-group h3 {
    font-size: 1.3rem;
    color: #667eea;
    margin-bottom: 20px;
    font-weight: 700;
  }
  
  .partner-links,
  .resource-links {
    list-style: none;
    padding: 0;
  }
  
  .partner-links li {
    margin-bottom: 15px;
    padding-bottom: 15px;
    border-bottom: 1px solid #e0e0e0;
  }
  
  .partner-links li:last-child {
    border-bottom: none;
  }
  
  .partner-links a {
    color: #333;
    text-decoration: none;
    font-weight: 600;
    font-size: 1.05rem;
    transition: color 0.3s ease;
    display: block;
    margin-bottom: 5px;
  }
  
  .partner-links a:hover {
    color: #667eea;
  }
  
  .link-desc {
    font-size: 0.85rem;
    color: #666;
  }
  
  .resource-links li {
    margin-bottom: 12px;
  }
  
  .resource-links a {
    color: #667eea;
    text-decoration: none;
    font-size: 0.95rem;
    transition: all 0.3s ease;
    display: inline-block;
  }
  
  .resource-links a:hover {
    color: #764ba2;
    transform: translateX(5px);
  }
  
  .featured-logos {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
  }
  
  .logo-placeholder {
    background: white;
    padding: 10px 20px;
    border-radius: 8px;
    font-size: 0.9rem;
    font-weight: 600;
    color: #666;
    box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  }
  
  @media (max-width: 768px) {
    .backlinks-section {
      padding: 30px 15px;
    }
    
    .backlinks-container {
      gap: 30px;
    }
  }
</style>
